import { useContext, useEffect, useMemo, useState } from 'react'
import { ReportService } from '../../../services/ReportsService'
import { MessageUtil } from '../../../utils/message'
import { ChannelUtil } from '../../../utils/channel'
import { DateUtil } from '../../../utils/date'
import { useCurrentAccount } from '../../../hooks/useCurrentAccount'
import { LocalStorageService } from '../../../services/LocalStorageService'
import { APPS, STORAGE, TYPE_MESSAGES } from '../../../constants'
import { AlertService } from '../../../services/Alert'
import ContactInfo from './ContactInfo'
import GreetingPage from '../GreetingPage'
import { FollowUpService } from '../../../services/FollowUpService'
import { FollowUpTicketsContext } from '../../../context/FollowUpTicketsContext'
import RedirectModal from "./RedirectModal";
import Message from '../../../components/Message'
import { useTranslation } from 'react-i18next'
import useRequest from '../../../hooks/useRequest'
import Loader from '../../../components/Loader'

export default function TicketChatView(reload) {

    const { t } = useTranslation();
    const onlyNumbers = /\D+/g;
    const {call, isRequesting} = useRequest();
    const { ticketSelected, setTicketSelected, newMessage } = useContext(FollowUpTicketsContext);

    // const [ticket, setTicket] = useState(null);
    const [customer, setCustomer] = useState(null);
    const [isTicketClosed, setIsTicketClosed] = useState(false);
    const [messages, setMessages] = useState([]);
    const [TicketModal, setTicketModal] = useState('');
    const [Agents, setAgents] = useState([]);
    const [showModal, setshowModal] = useState(false);
    const { account } = useCurrentAccount();
    const session = useMemo(() => LocalStorageService.get(STORAGE.SESSION), []);
    const initialsCustomer = useMemo(() => {
        if (!ticketSelected?.name_client) return;

        return ticketSelected.name_client[0].toUpperCase()
    }, [ticketSelected])

    const downloadDocument = async (url) => {
        await AlertService.warning('Descargar archivo', '¿Te gustaría realizar la descarga de este archivo?', async () => {
            try {
                window.open(url, '_blank');
            } catch (error) {
                console.error(error);
                AlertService.error('¡Error!', 'Ocurrió un error al descargar el archivo, intenta nuevamente')
            }
        });
    }

    const getMessagesLive = async () => {
        const { data } = await call(() => FollowUpService.getMessagesLive(ticketSelected.id));
        setIsTicketClosed(false);
        setMessages(data.reverse())
    }
    
    const getInfoClient = async () => {
        const { data } = await call(() => FollowUpService.getInfoClient({ account_client_id: ticketSelected.account_key_client }));

        setCustomer(data)        
    }

    const getAgentsData = async () => {
        const { data } = await FollowUpService.getAgents(account.id);
        setAgents(data);
    }

    useEffect(() => {
        if (ticketSelected) {
            setTicketModal(ticketSelected.id)
            getMessagesLive()
            getInfoClient()
        } else {
            setMessages([])
        }
    }, [ticketSelected])


    useEffect(() => {
        setTicketModal(ticketSelected.id)
        if (newMessage && ticketSelected.id === newMessage.ticketID) {

            const exists = messages.find(m => m.id === newMessage.id)
            if (!exists) {
                setMessages(msgs => [newMessage, ...msgs])
            }
        }
    }, [newMessage])

    useEffect(() => {
        getAgentsData();
    }, []);

    const CloseTicketHandler = (id: string) => {
        if (id === 'close') {
            AlertService.warning(t("follow-up.tickets.chat-view.question-close"), t("follow-up.tickets.chat-view.text-close"), async () => {
                try {
                    await FollowUpService.closeTickets(ticketSelected.id)
                    AlertService.toastSuccess(t("follow-up.tickets.chat-view.toast-success-close"))
                    const event = new CustomEvent('updateTickets');
                    window.dispatchEvent(event);
                    setIsTicketClosed(true);
                } catch (error) {
                    console.error(error);
                    AlertService.error('¡Error!', t("follow-up.tickets.chat-view.alert-error-close"))
                }
            });
        } else if (id === 'release') {
            AlertService.warning(t("follow-up.tickets.chat-view.question-release"), t("follow-up.tickets.chat-view.text-release"), async () => {
                try {
                    await FollowUpService.releaseTickets(ticketSelected.id)
                    AlertService.toastSuccess(t("follow-up.tickets.chat-view.toast-success-release"))
                    const event = new CustomEvent('updateTickets');
                    window.dispatchEvent(event);
                } catch (error) {
                    console.error(error);
                    AlertService.error('¡Error!', t("follow-up.tickets.chat-view.alert-error-release"))
                }
            });
        } 
    }

    const handleHideModal = () => {
        setshowModal(false)
    }

    return (
        <>
            {!isTicketClosed && (
                <>
                    <div className="col-6 p-0" >
                        <div className="bg-light border h-100 d-flex flex-column">
                            <div className="bg-white border-bottom shadow-sm" style={{ padding: '18px' }}>
                                <div className="d-flex align-items-center">
                                    <span className="avatar avatar-primary avatar-circle">
                                        {(() => {
                                            switch (ticketSelected.app.toUpperCase()) {
                                                case APPS.WHATSAPP_BUSINESS:
                                                    return <span className="avatar avatar-circle px-0"><img className="avatar-img" src="/assets/img/waBusiness.jpg" alt="Image Description" /></span>;
                                                case APPS.WHATSAPP_STANDAR:
                                                    return <span className="avatar avatar-circle px-0"><img className="avatar-img" src="/assets/img/waStandard.jpg" alt="Image Description" /></span>;
                                                case APPS.SMS:
                                                    return <span className="avatar avatar-circle px-0"><img className="avatar-img" src="/assets/img/smsLogo.jpg" alt="Image Description" /></span>;
                                                case APPS.RCS:
                                                    return <span className="avatar avatar-circle px-0"><img className="avatar-img" src="/assets/img/rcsLogo.jpg" alt="Image Description" /></span>;
                                                default:
                                                    return <div></div>;
                                            }
                                        })()}
                                    </span>
                                    <div className="ms-2 ">
                                        <h4 className="mb-0">{ticketSelected?.name_client}</h4>
                                        <p className="m-0 form-text">{ticketSelected?.chat_number?.replace(onlyNumbers, '')}</p>
                                        <p className='text-muted m-0 form-text'><strong>Ticket ID:</strong> {ticketSelected?.id}</p>
                                    </div>
                                    <div className="ms-auto">
                                        {/* <button className="btn bg-soft-primary btn-sm  border">
                                       <i className="bi-download"></i> {t('follow-up.tickets.conversation.download-btn')}
                                   </button> */}
                                    </div>
                                    <div className="dropdown nav-scroller-dropdown">
                                        <button type="button" className="btn btn-ghost-secondary btn-icon btn-sm card-dropdown-btn rounded-circle" id="profileDropdown" data-bs-toggle="dropdown" aria-expanded="false">
                                            <i className="bi-three-dots-vertical"></i>
                                        </button>

                                        <div className="dropdown-menu dropdown-menu-end mt-1" aria-labelledby="profileDropdown">
                                            <span className="dropdown-header"> {t("follow-up.tickets.chat-view.actions-menu")}</span>

                                            <a className="dropdown-item cursor-pointer" onClick={() => CloseTicketHandler('close')}>
                                                <i className="bi-x-circle dropdown-item-icon" ></i> {t("follow-up.tickets.chat-view.actions-menu-opcion1")}
                                            </a>
                                            <a className="dropdown-item" onClick={() => CloseTicketHandler('release')}>
                                                <i className="bi-star dropdown-item-icon"></i> {t("follow-up.tickets.chat-view.actions-menu-opcion2")}
                                            </a>
                                            <a className="dropdown-item" onClick={() => { setshowModal(true) }}>
                                                <i className="bi-send dropdown-item-icon"></i>  {t("follow-up.tickets.chat-view.actions-menu-opcion3")}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="p-3 flex-grow-1 d-flex flex-column-reverse overflow-scroll sidebar relative" >
                                {
                                    isRequesting? <Loader/> : messages.filter(message => message.type.toUpperCase() !== TYPE_MESSAGES.SYSTEM).map((message) => <Message key={message.id} ticket={{ ...ticketSelected, name_client: ticketSelected.name_client } as any} message={message} />)
                                }
                            </div>

                            {/* <div className="bg-white border-top shadow-sm p-3">
                           <div className="text-center">
                               <p className="h5">{t('follow-up.tickets.conversation.warning-footer-title')}</p>
                               <p className="small">{t('follow-up.tickets.conversation.warning-footer-text')}</p>
                           </div>
                       </div> */}
                        </div>

                    </div>
                    <ContactInfo
                        initialsCustomer={initialsCustomer}
                        ticket={ticketSelected}
                        customer={customer}
                    />
                </>
            )}


            {isTicketClosed && <GreetingPage />}

            <RedirectModal
                show={showModal}
                onRequestClose={handleHideModal}
                ticket={TicketModal}
                fromAgentid={ticketSelected.agent_id}
            />
        </>
    )
}
